import UnderlineCurve from 'components/curves/UnderlineCurve';
import Link from 'components/links/Link';
import { NextSeo } from 'next-seo';
import React, { useContext, useState } from 'react';

import Button from 'components/buttons/Button';
import Footer from 'components/Footer';
import AddPhotosVideoModal from 'components/photo-contest/AddPhotosVideoModal';
import AddPoiVideoModal from 'components/photo-contest/AddPoiVideoModal';
import Countdown from 'components/photo-contest/Countdown';
import CountdownCurveSvg from 'components/photo-contest/CountdownCurveSvg';
import documents from 'config/documents';
import pages from 'config/pages';
import NikonZ30 from 'components/photo-contest/Nikon-z30';
import NikonVideo from 'components/photo-contest/NikonVideo';
import { useLocalStorage } from 'react-use';
import HowToParticipate from 'components/photo-contest/HowToParticipate';
import AppContext from 'contexts/AppContext';
import { setSearchDialogActive } from 'contexts/AppActions';
import WinnerPage from 'components/photo-contest/Winner';

function CtaButton({ label = 'Naloži fotografije in sodeluj' }) {
    const [, setHasClosedCard] = useLocalStorage('search-contest-card-closed', true);
    const { dispatch } = useContext(AppContext);
    const handleClick = () => {
        setHasClosedCard(true);
        setSearchDialogActive(dispatch, true);
    };
    return (
        <Button color="secondary" onClick={handleClick}>
            {label}
        </Button>
    );
}

function FotoIzborPage() {
    const dateCountdown = Date.parse('31 Jul 2023 23:59:59 GMT+2');
    const [openedModal, setOpenedModal] = useState<string>();
    const { state } = useContext(AppContext);

    const contestState = state.photoContest.state;

    if (contestState === 'FINISHED') return <WinnerPage />;

    return (
        <>
            <NextSeo
                title={pages.photoContest.title}
                description={pages.photoContest.seo.description}
                openGraph={{
                    description: pages.photoContest.seo.description,
                    title: pages.photoContest.seo.title,
                    images: [{ url: 'https://kamzavikend.si/images/foto-izbor/share.png' }],
                    url: 'https://kamzavikend.si/foto-izbor'
                }}
            />
            <div className="single-page nagradni-izbor lg:pt-12">
                <div className="container">
                    <section className="hero flex flex-col lg:flex-row lg:gap-12 max-w-6xl mx-auto" id="hero">
                        <div>
                            <img
                                src="/images/foto-izbor/hero-photos.jpg"
                                alt="Fotografije Slovenije"
                                width="337"
                                height="493"
                                className="hidden lg:block"
                            />
                            <img
                                src="/images/foto-izbor/hero-photos-mobile.jpg"
                                alt="Fotografije Slovenije"
                                width="356"
                                height="228"
                                className="lg:hidden"
                            />
                        </div>
                        <div className="flex items-center">
                            <div className="content max-w-lg">
                                <h1>
                                    <UnderlineCurve height={20}>Nagrajujemo</UnderlineCurve>
                                    <br /> lepe fotografije Slovenije.
                                </h1>
                                {contestState === 'ACTIVE' && (
                                    <>
                                        <p className="pt-4">
                                            Naloži svoje fotografije lepot Slovenije in osvoji vsestranski fotoaparat{' '}
                                            <span className="text-brand font-bold">
                                                Nikon Z 30 v vrednosti 799,99 €
                                            </span>
                                            , ki ga poklanjata Nikon in BigBang, partnerja nagradnega foto izbora.
                                        </p>
                                        <p className="pt-4 lg:pb-4">
                                            Osvojiš lahko tudi eno od{' '}
                                            <span className="text-brand font-bold">15 majic Kam za vikend</span>.
                                            Prejemnike bomo izžrebali izmed vseh naloženih fotografij v času foto
                                            izbora.{' '}
                                        </p>
                                    </>
                                )}
                                {contestState === 'VOTING' && (
                                    <>
                                        <p className="pt-4">
                                            <strong>Nagradni izbor je zaključen!</strong>
                                        </p>
                                        <p className="pt-4">
                                            Ekipa Kam za vikend je izbrala 40 najlepših fotografij Slovenije. Glasuj za
                                            svojega favorita in osvoji KZV majico.
                                        </p>
                                    </>
                                )}

                                {contestState === 'ACTIVE' && (
                                    <>
                                        <div className="text-center">
                                            <img
                                                src="/images/foto-izbor/landing-nagrade-mobile@2x.png"
                                                alt="Nagrade Kam za vikend foto izbora"
                                                width="750"
                                                height="1003"
                                                className="lg:hidden max-h-96 w-auto -mt-8 mb-6 inline-block"
                                            />
                                        </div>
                                        <p className="text-sm">
                                            Klikni spodaj, poglej katere točke sodelujejo v natečaju, naloži lepe
                                            fotografije Slovenije iz svojega telefona, fotoaparata ali računalnika in
                                            sodeluj.{' '}
                                            <Link to={documents.photoContestRules} target="_blank" styles="font-bold">
                                                Poglej pravila sodelovanja.
                                            </Link>
                                        </p>
                                        <div className="cta my-6 flex flex-col md:flex-row items-center gap-2">
                                            <CtaButton />
                                            <Button variant={'outlined'} color={'secondary'} link={'#kako-sodelujem'}>
                                                Kako sodelujem?
                                            </Button>
                                        </div>
                                    </>
                                )}

                                {contestState === 'VOTING' && (
                                    <div className="cta my-6">
                                        <Button color="secondary" variant="contained" link="/foto-izbor/finalisti">
                                            Glasuj za zmagovalca
                                        </Button>
                                    </div>
                                )}

                                <p>
                                    <small>PARTNERJA</small>
                                </p>
                                <div className="flex items-center gap-3">
                                    <Link to="https://bigbang.si" target="_blank">
                                        <img
                                            src="/images/foto-izbor/bigbang-logo.svg"
                                            alt="Big bang Slovenija"
                                            className="inline-block h-8"
                                        />
                                    </Link>

                                    <img
                                        src="/images/foto-izbor/logo-nikon.svg"
                                        alt="Nikon"
                                        className="inline-block h-8"
                                    />
                                </div>
                            </div>
                            <div className="">
                                {contestState === 'ACTIVE' && (
                                    <img
                                        src="/images/foto-izbor/landing-nagrade.png"
                                        alt="Nagrade Kam za vikend foto izbora"
                                        width={560}
                                        height={542}
                                        className="hidden lg:block max-w-7xl w-[110%] relative  filter drop-shadow-2xl"
                                    />
                                )}
                            </div>
                        </div>
                    </section>
                </div>
                {contestState === 'ACTIVE' ? (
                    <section id="countdown" className="my-12 bg-brand-dull py-8 relative">
                        <div className="absolute -top-4 w-full">
                            <CountdownCurveSvg />
                        </div>
                        <div className="container">
                            <div className="flex flex-col lg:flex-row justify-center items-center gap-8">
                                <h3 className="text-brand text-2xl text-center">Časa za nagrado je še:</h3>
                                <div>
                                    <Countdown date={dateCountdown} />
                                </div>
                            </div>
                        </div>
                        <div className="absolute -bottom-4 w-full">
                            <CountdownCurveSvg />
                        </div>
                    </section>
                ) : (
                    <div className="py-12"></div>
                )}
                <section id="nikon" className="lg:py-12">
                    <NikonZ30 />
                </section>
                <section id="video" className="mt-20">
                    <NikonVideo />
                    {contestState === 'ACTIVE' && (
                        <div className="mt-12 text-center">
                            <CtaButton label="Naloži fotografije in Nikon Z 30 je lahko tvoj" />
                        </div>
                    )}
                </section>
                {contestState === 'ACTIVE' && (
                    <section id="kako-sodelujem" className="py-24">
                        <div className="container">
                            <h2 className="text-center text-brand mb-6">Kako sodeluješ v nagradnem foto izboru?</h2>
                            <HowToParticipate />
                        </div>
                    </section>
                )}
                <section id="rules" className="text-left pb-12 lg:pb-36">
                    <div className="container flex flex-col gap-6 items-center mt-6">
                        {contestState === 'ACTIVE' && <CtaButton />}
                        {contestState === 'VOTING' && (
                            <Button color="secondary" variant="contained" link="/foto-izbor/finalisti">
                                Glasuj za zmagovalca
                            </Button>
                        )}

                        <Button link={documents.photoContestRules} target="_blank" color="secondary" variant="text">
                            Pravila nagradnega izbora
                        </Button>
                    </div>
                </section>
                <Footer />
                <AddPhotosVideoModal open={openedModal === 'add-photos'} onClose={() => setOpenedModal(null)} />
                <AddPoiVideoModal open={openedModal === 'add-poi'} onClose={() => setOpenedModal(null)} />
            </div>
        </>
    );
}

export default FotoIzborPage;
